import { useState } from 'react';
import { Modal } from '../components/Modal';

type Props = {
    onClose: () => void;
    onCreate: (battle: { bet: number; opponents: number; highlight: boolean }) => void;
    minBet: number;
    highlightFee: number;
    balance: number;
};

/**
 * "Создать батл" form. Bet validation matches the spec: at least the minimum
 * configured by root, and the user must hold enough BSP to cover stake +
 * the optional "выделить цветом" fee.
 */
export function CreateBattleModal({ onClose, onCreate, minBet, highlightFee, balance }: Props) {
    const [bet, setBet] = useState('');
    const [opponents, setOpponents] = useState(2);
    const [highlight, setHighlight] = useState(false);

    const betNum = Number.parseFloat(bet.replace(',', '.'));
    const total = (Number.isFinite(betNum) ? betNum : 0) + (highlight ? highlightFee : 0);
    const valid = Number.isFinite(betNum) && betNum >= minBet && total <= balance;

    return (
        <Modal title="Создать батл" onClose={onClose}>
            <div className="input-group">
                <label>Сумма ставки (BSP)</label>
                <input
                    type="number"
                    inputMode="decimal"
                    placeholder={`Минимум ${minBet}`}
                    value={bet}
                    onChange={(e) => setBet(e.target.value)}
                />
            </div>

            <div className="input-group">
                <label>
                    Участников: <span className="text-red fw-900">{opponents}</span>
                </label>
                <input
                    type="range"
                    min={1}
                    max={5}
                    value={opponents}
                    style={{ accentColor: 'var(--red)' }}
                    onChange={(e) => setOpponents(Number(e.target.value))}
                />
            </div>

            <label className="checkbox-row" style={{ justifyContent: 'flex-start', gap: 10 }}>
                <input
                    type="checkbox"
                    checked={highlight}
                    onChange={(e) => setHighlight(e.target.checked)}
                />
                <span className="text-accent fw-900 f-12">
                    Выделить цветом (+{highlightFee} BSP)
                </span>
            </label>

            <div className="calc-box">
                <span className="text-muted f-12">К списанию:</span>
                <div
                    className="text-accent fw-900"
                    style={{ fontSize: 18, marginTop: 4 }}
                >
                    {total.toFixed(2)} BSP
                </div>
            </div>

            <button
                type="button"
                className="action-btn btn-red"
                disabled={!valid}
                onClick={() => onCreate({ bet: betNum, opponents, highlight })}
            >
                Создать батл
            </button>
        </Modal>
    );
}
